module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Graphic",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035842124_Txt.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Graphic",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035842124_Txt2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Heading ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Copyright © Robyn Smythe 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The right of "), _c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Robyn Smythe")]), _vm._v(" to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("ISBN 9781035842124 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("ISBN 9781035842131 (ePub-e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("www.austinmacauley.co.uk")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Austin Macauley Publishers Ltd"), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("® ")])]), _vm._v(" "), _c('p', {
    staticClass: "Blurb",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("1 Canada Square")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Canary Wharf")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "Blurb",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "Dedi ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This book is dedicated to all the cat lovers out there around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("I hope you enjoy my purr-fect tail.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("                                                                                                            Rx")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "Graphic",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035842124_Txt6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub4.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer017"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub7.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer023"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub9.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub10.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer029"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub11.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer031"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub12.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer033"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub13.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer035"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub14.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer037"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub15.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer039"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub16.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer041"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/9781035842131_Epub17.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer043"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a71c716e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035842131_Epub.vue
// module id = 57
// module chunks = 0